import TextSwitcher from "components/TextSwitcher";
import type { TextSwitcherProps } from "components/TextSwitcher";
import type { ReactStoryblokComponent } from "modules/storyblok/types";

const TextSwitcherAdapter = ({ blok: { heading, text, content } }: ReactStoryblokComponent<TextSwitcherProps>) => (
  <TextSwitcher heading={heading} content={content} text={text} />
);

export default TextSwitcherAdapter;
